import React from 'react';
import PrevNextButtons from '../ui/buttons/PrevNextButtons/PrevNextButtons';
import { AppDispatch } from '../../store/store';
import { AppState } from '../../store/state';
import { connect } from 'react-redux';
import { selectSubmissionState, selectTable } from '../../store/selectors';
import { FilterIdsKey } from '../../store/table/types';
import { Submission } from '../../store/submission/types';

interface Props {
  rowId: number;
  type: FilterIdsKey;
  filteredIds: { [key in FilterIdsKey]: number[] | undefined };
  onMove: (rowId: number) => void;
  submissionsById: { [key: string]: Submission };
  className?: string;
  children: React.ReactNode;
}

const PrevNextButtonsCtrl: React.FC<Props> = ({ rowId, type, filteredIds, onMove, submissionsById, ...rest }) => {
  let rowIds = filteredIds[type] ?? [];
  if (!rowIds.length && type == 'App\\Models\\Submission') {
    rowIds = Object.keys(submissionsById).map((value) => parseInt(value));
  }

  const findIndex = rowIds.findIndex((id) => id == rowId);
  return (
    <PrevNextButtons
      {...rest}
      currIndex={findIndex}
      arrLength={rowIds.length}
      onMove={(index) => {
        const rId = rowIds[index];
        if (rId && rId != rowId) {
          onMove(rId);
        }
      }}
    />
  );
};

const mapStateToProps = (state: AppState) => ({
  filteredIds: selectTable(state).filteredIds,
  submissionsById: selectSubmissionState(state).submissionsById,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(PrevNextButtonsCtrl);
